import { HiBadgeCheck } from "react-icons/hi";
import { BsCloudDownload } from "react-icons/bs";
import documentPDF from './assets/documents/EximPe_Customer-Grievance-Redressal-Policy.pdf';
import { trackPageView} from '../../utlis/useAnalytics';
import { useEffect } from 'react';
import {PageName} from '../../configs/config'
import { Helmet } from "react-helmet-async";


export default function Policy() {
  useEffect(() => {
    trackPageView(PageName.Redressal);
  }, []);

  return (
      <><Helmet>
      <title>EximPe Grievance Redressal Policy – We're Here to Listen</title>
      <meta name="description" content="Learn about EximPe’s Grievance Redressal Policy. Discover our transparent process for addressing customer complaints and ensuring quick, fair resolutions." />
    </Helmet>
    <div className="mt-[140px] text-[#1A202C] lg:px-[12%] ">
        <div className="bg-white font-sans leading-normal tracking-normal">
          {/* Container */}
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8">
            {/* Header */}
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-8">
              Introduction
            </h1>

            {/* Content */}
            <p className="mb-4 text-base sm:text-lg">
              RBI vide notification dated 17 March 2020 bearing reference number
              RBI/DPSS/2019-20/174 DPSS.CO.PD.No. 1810/ 02.14.008/2019-20 (“PA
              Guidelines”) has laid out regulations for all Payment Aggregators (PA)
              to ensure that a suitable mechanism is in place for receiving and
              addressing complaints from its Merchants with specific emphasis on
              resolving such complaints fairly and expeditiously regardless of source
              of the complaints.
            </p>

            <p className="mb-4 text-base sm:text-lg">
              This Grievance Redressal Policy has been formulated to provide
              Merchants and Customers adequate facilities to lodge and escalate their
              grievances, concerns and queries with Les Amis Pvt. Ltd. (EximPe)
              (hereinafter referred to as the “company”) and to provide a speedy and
              effective redressal mechanism for the same.
            </p>
          </div>
        </div>

        {/* Grievance redressal mechanism */}
        <div className="bg-white font-sans leading-normal tracking-normal mt-5">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-8">
              Grievance Redressal Mechanism
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* Left Column */}
              <div>
                <p className="mb-4 text-base sm:text-lg">
                  At{" "}
                  <span className="text-green-500 font-semibold">EximPe</span>, we
                  deeply value our relationship with each customer and are dedicated
                  to fostering transparent and honest communication. In our effort
                  to enhance customer experiences and address their concerns effectively,
                  we’ve introduced a dedicated grievance management framework, underpinned
                  by a detailed Grievance Policy.
                </p>
                <p className="mb-8 text-base sm:text-lg">
                  This policy is crafted to offer a comprehensive and orderly way to process
                  and resolve customer complaints. It encompasses a variety of channels through
                  which customers can lodge their grievances. Our primary focus with this policy
                  is to diminish instances of customer dissatisfaction by ensuring complaints are
                  addressed rapidly and effectively, using a clear and systematic review and
                  resolution procedure.
                </p>
                <a href={documentPDF} target="_blank" rel="noopener noreferrer">
                  <button className="flex items-center space-x-2 border border-green-500 px-4 py-2 rounded-lg hover:bg-green-100 transition duration-300">
                    <BsCloudDownload className="text-green-500" />
                    <span className="text-green-500 font-semibold">
                      Download Full Policy Document
                    </span>
                  </button>
                </a>

              </div>

              {/* Right Column */}
              <div>
                <p className="mb-4 text-base sm:text-lg">
                  The objective of our Grievance Policy shall be to ensure that:
                </p>
                <ul className="mt-5 md:mt-10 space-y-2 text-left text-sm sm:text-lg font-inter">
                  <li className="flex items-center">
                    <HiBadgeCheck className="text-[#26a887] mr-2 w-6 h-6 flex-shrink-0" />
                    <span className="flex-1">
                      At EximPe, every customer receives equal and unbiased attention consistently.
                    </span>
                  </li>
                  <li className="flex items-center">
                    <HiBadgeCheck className="text-[#26a887] mr-2 w-6 h-6 flex-shrink-0" />
                    <span className="flex-1">
                      We handle grievances raised by customers with utmost respect and aim for quick resolution.
                    </span>
                  </li>
                  <li className="flex items-center">
                    <HiBadgeCheck className="text-[#26a887] mr-2 w-6 h-6 flex-shrink-0" />
                    <span className="flex-1">
                      EximPe ensures customers are informed about the different levels they can escalate their complaints to within the organization.
                    </span>
                  </li>
                  <li className="flex items-center">
                    <HiBadgeCheck className="text-[#26a887] mr-2 w-6 h-6 flex-shrink-0" />
                    <span className="flex-1">
                      We keep customers informed about their entitlements for seeking alternative solutions if the company's resolutions are not satisfactory.
                    </span>
                  </li>
                  <li className="flex items-center">
                    <HiBadgeCheck className="text-[#26a887] mr-2 w-6 h-6 flex-shrink-0" />
                    <span className="flex-1">
                      EximPe is committed to processing any refunds or chargebacks efficiently, adhering strictly to the deadlines and requirements as stipulated by the Reserve Bank of India (RBI) and other necessary protocols.
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Registration and Tracking of Complaints */}
        <div className="bg-white font-sans leading-normal tracking-normal mt-5">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-8">
              Registration and Tracking of Complaints
            </h2>

            <p className="text-base sm:text-lg text-center mb-8">
              Based on the nature of the ticket, the complaints shall be classified into different buckets.
              Customers can reach out to EximPe through any of the below listed channels.
            </p>

            <div className="overflow-x-auto rounded-3xl">
              <table className="min-w-full divide-y divide-gray-200">
                <thead>
                  <tr>
                    <th
                      scope="col"
                      className="px-6 py-3 bg-[#27a887] text-white text-left text-sm font-medium"
                    >
                      Channel Name
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 bg-[#27a887] text-white text-left text-sm font-medium"
                    >
                      Contact Details
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  <tr>
                    <td className="px-6 py-4 whitespace-nowrap">Email</td>
                    <td className="px-6 py-4 whitespace-nowrap">support@eximpe.com</td>
                  </tr>
                  <tr className="bg-[#f6f6f6]">
                    <td className="px-6 py-4 whitespace-nowrap">Support Desk</td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <a
                        href="https://eximpe.freshdesk.com/support/tickets/new"
                        className="text-teal-500 hover:underline"
                      >
                        Raise a Ticket
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td className="px-6 py-4 whitespace-nowrap">
                      Customer Care/Help Line Number
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">+91 9497707982</td>
                  </tr>
                  <tr className="bg-[#f6f6f6]">
                    <td className="px-6 py-4 whitespace-nowrap">WhatsApp</td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      WhatsApp chat is integrated in the application and on the official website or can be directly contacted at +91 6909016944
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Grievance Redressal and Resolution */}
        <div className="bg-white font-sans leading-normal tracking-normal mt-5">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-8">
              Grievance Redressal and Resolution
            </h2>

            <p className="text-base sm:text-lg text-center mb-8">
              EximPe shall have a three-tier escalation mechanism for handling customer grievances.
            </p>

            <div className="overflow-x-auto rounded-3xl">
              <table className="min-w-full divide-y divide-gray-200">
                <thead>
                  <tr>
                    <th
                      scope="col"
                      className="px-6 py-3 bg-[#27a887] text-white text-left text-sm font-medium"
                    >
                      Escalation Level
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 bg-[#27a887] text-white text-left text-sm font-medium"
                    >
                      Designation
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 bg-[#27a887] text-white text-left text-sm font-medium"
                    >
                      Resolution Time
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 bg-[#27a887] text-white text-left text-sm font-medium"
                    >
                      Contact
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  <tr className="bg-[#f6f6f6]">
                    <td className="px-6 py-4 whitespace-nowrap">Level 1</td>
                    <td className="px-6 py-4 whitespace-nowrap">Customer Service Team</td>
                    <td className="px-6 py-4 whitespace-nowrap">3 Business Days</td>
                    <td className="px-6 py-4 whitespace-nowrap">support@eximpe.com</td>
                  </tr>
                  <tr>
                    <td className="px-6 py-4 whitespace-nowrap">Level 2</td>
                    <td className="px-6 py-4 whitespace-nowrap">Operations Head</td>
                    <td className="px-6 py-4 whitespace-nowrap">3 Business Days</td>
                    <td className="px-6 py-4 whitespace-nowrap">batul@eximpe.com</td>
                  </tr>
                  <tr className="bg-[#f6f6f6]">
                    <td className="px-6 py-4 whitespace-nowrap">Level 3</td>
                    <td className="px-6 py-4 whitespace-nowrap">Nodal Officer</td>
                    <td className="px-6 py-4 whitespace-nowrap">3 Business Days</td>
                    <td className="px-6 py-4 whitespace-nowrap">syed@eximpe.com</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p className="mt-8 text-base sm:text-lg">
              The customer can approach the Ombudsman in case an appropriate resolution is not received at previous levels within 30 days in line with RBI Guidelines – Integrated Ombudsman Scheme, 2021.
            </p>
          </div>
        </div>

        {/* Escalation Level Cards */}
        <div className="bg-white font-sans leading-normal tracking-normal mt-5">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {/* Level 1 Card */}
              <div className="bg-white p-6 rounded-lg shadow-md">
                <p className="text-gray-500 text-sm mb-2">Level 1</p>
                <h3 className="text-lg sm:text-xl font-bold mb-4">Customer Service Team</h3>
                <p className="text-gray-700 text-sm sm:text-base">
                  Complaints received by email, Freshdesk support ticket, WhatsApp or through the helpdesk numbers shall be acknowledged within 24 hours by an immediate system-generated response or via individual emails. The customer will also be kept informed of the action taken, the progress while redressing grievances, and/or the reasons for delay if any, in redressing. The TAT or expected time for resolution will also be communicated.
                </p>
              </div>

              {/* Level 2 Card */}
              <div className="bg-white p-6 rounded-lg shadow-md">
                <p className="text-gray-500 text-sm mb-2">Level 2</p>
                <h3 className="text-lg sm:text-xl font-bold mb-4">Operations Head</h3>
                <p className="text-gray-700 text-sm sm:text-base mb-4">
                  Customer can address the grievance to the below address for escalations:
                </p>
                <div className="mb-4">
                  <p className="font-bold text-sm sm:text-base">Batul Huzefa</p>
                  <p className="text-sm sm:text-base">Operations Head</p>
                  <p className="text-sm sm:text-base">EximPe, WeWork Express Towers,</p>
                  <p className="text-sm sm:text-base">Nariman Point, Marine Drive Mumbai,</p>
                  <p className="text-sm sm:text-base">Maharashtra, India 400021</p>
                </div>
                <p className="text-sm sm:text-base">
                  Email:{" "}
                  <a href="mailto:batul@eximpe.com" className="text-teal-500 hover:underline">
                    batul@eximpe.com
                  </a>
                </p>
              </div>

              {/* Level 3 Card */}
              <div className="bg-white p-6 rounded-lg shadow-md">
                <p className="text-gray-500 text-sm mb-2">Level 3</p>
                <h3 className="text-lg sm:text-xl font-bold mb-4">Nodal Officer</h3>
                <p className="text-gray-700 text-sm sm:text-base mb-4">
                  The customer can escalate the matter to:
                </p>
                <div className="mb-4">
                  <p className="font-bold text-sm sm:text-base">Syed Arief Ulla</p>
                  <p className="text-sm sm:text-base">Key Account Manager</p>
                  <p className="text-sm sm:text-base">EximPe, WeWork Express Towers,</p>
                  <p className="text-sm sm:text-base">Nariman Point, Marine Drive Mumbai,</p>
                  <p className="text-sm sm:text-base">Maharashtra, India 400021</p>
                </div>
                <p className="text-sm sm:text-base">
                  Email:{" "}
                  <a href="mailto:syed@eximpe.com" className="text-teal-500 hover:underline">
                    syed@eximpe.com
                  </a>
                </p>
                <p className="text-sm sm:text-base">
                  Ph: <span className="font-bold">+91 86602 59150</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div></>
  );
}
